import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { checkNameShowHide, nameMask } from "../utils/utils";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ChatOnlineMatches() {

  // 🔹 Redux data
  const { userDetailLogin, planDetailUser } = useSelector(
    (state) => state.auth
  );

  // 🔹 Prevent undefined errors
  const blurPhoto = 0; // set 1 if blur required

  // 🔹 Safe token parsing
  const rawToken =
    Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser");
  const token = rawToken ? JSON.parse(decodeURIComponent(rawToken)) : null;

  const [searchData, setSearchData] = useState([]);

  const searchList = async () => {
    try {
      setSearchData([]);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/api/front/search-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
          body: JSON.stringify({
            member_id: userDetailLogin?._id,
            page: 1,
            my_matches: 1,
          }),
        }
      );

      const data = await res.json();
      setSearchData(data?.data || []);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  useEffect(() => {
    searchList();
  }, []);
  
  return (
    <div className="man-chat-box d-flex">

      {/* 🔹 Online Matches */}
      {searchData?.length > 0 &&
        searchData.map((item, index) => {
          let profilePhotoShow = null;

          if (item?.profile_photo === 1) {
            profilePhotoShow =
              blurPhoto === 1 ? item?.photo_blur : item?.photo;
          }

          const defaultImage =
            item?.gender === "Male"
              ? "assets/img/no-image-male.jpg"
              : "assets/img/no-image-female.jpg";

          return (
            <Link to={`/profile-details/${item?._id}`} key={item?._id || index}>
              <div className="image-chat">
                <div className="man-cat-box">
                  <img
                    src={
                      profilePhotoShow
                        ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhotoShow}`
                        : defaultImage
                    }
                    alt="profile"
                  />
                </div>

                <span />

                <h6>
                  {checkNameShowHide(
                    item?.profileSettings?.name_show,
                    planDetailUser
                  )
                    ? item?.name
                    : nameMask(item?.name)}
                </h6>
              </div>
            </Link>
          );
        })}

      {/* 🔹 View All */}
      <div className="image-chat-last">
        <Link to="/my-matches">
          <div className="chat-last">
            <p>+5</p>
          </div>
          View All
        </Link>
      </div>
    </div>
  );
}
